module.exports = __webpack_public_path__ + "img/ic_benifit_idiom.a1575551.png";